module.exports = __webpack_public_path__ + "static/media/diskcopy_1.c0d64c2c.ico";